
/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { CircularProgress } from "@material-ui/core";
import { getRequest } from "utils/request";

import TabWhatsapp from "./TabWhatsApp";
import TabFacebook from "./TabFacebook";
import TabInstagram from "./TabInstagram";
import TabChat from "./TabChat";

import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

import { i18n } from '../../../translate/i18n';

import { useParams } from 'react-router-dom'
import TabSkute from "./TabSkute";
import TabWhatsappQrCode from "./TabWhatsAppQrCode";

export default function TabChannels({ companyData, handleUpdate }) {
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [channels, setChannels] = useState([]);
  const [update, setUpdate] = useState(0);

  const { id } = useParams();


  const loadCompanyChannels = async () => {
    setLoading(true);

    //BUSCA LISTA DE CANAIS
    const ReturnGet = await getRequest(
      `/companies/admin/${id}`
    );
    if (ReturnGet.success) {
      const data = ReturnGet.data.CompanyChannels.sort((a, b) => {
        return (a.Channel.description > b.Channel.description) ? 1 : ((b.Channel.description > a.Channel.description) ? -1 : 0)
      })
      setChannels(data);
    }
    setLoading(false);
  }

  useEffect(() => {
    loadCompanyChannels();
  }, [update]);


  const handleGoBack = () => {
    setPage(0);
    setUpdate(update + 1);
    handleUpdate(10);
  };

  const handleEditChannel = (data) => {
    setPage(data.ChannelId);
  };

  const actionButtonsTemplate = (data) => {
    return (
      <div style={{ display: "flex", flexDirection: "row" }}>
        <div
          className="action-icon"
          style={{ cursor: "pointer", marginRight: 10 }}
          onClick={() => handleEditChannel(data)}
        >
          <i className="mdi mdi-pencil" style={{ fontSize: 20 }}></i>
        </div>
      </div>
    )
  }

  const logoTemplate = (data) => {
    return (
      <img
        alt={data.Channel.description}
        className="image-perfil-avatar-channel"
        src={data.Channel.image}
      />
    )
  }

  const channelTemplate = (data) => {
    return (
      <span>{data.Channel.description}</span>
    )
  }

  return (
    <div style={{ minHeight: 300 }} className="list-container">
      {page === 0 ? (
        <div>
          <div className="title-helper-container" style={{ marginBottom: 10 }}>
            <h3>{companyData.nickName}</h3>
          </div>
          {!loading ? (
            <div className="tab-content">
              <div className="tab-pane show active" id="basic-datatable-preview">
                <DataTable
                  dataKey="id"
                  rowsPerPageOptions={[5, 10, 25, 50]}
                  value={channels}
                  paginator
                  rows={5}
                  emptyMessage={i18n.t('noChannelsFinded')}
                >
                  <Column body={logoTemplate} field="logo" header={i18n.t('logo')}></Column>
                  <Column body={channelTemplate} field="channel" header={i18n.t('channel')}></Column>
                  <Column body={actionButtonsTemplate} field="action" header={i18n.t('action')}></Column>
                </DataTable>
              </div>
            </div>
          ) : (
            <div className="area-loading">
              <CircularProgress />
            </div>
          )}
        </div>
      ) : (
        <>
          {(page === 1 &&
            <TabWhatsapp
              handleGoBack={handleGoBack}
              handleUpdate={handleUpdate}
              companyData={companyData}
            />)
            || (page === 2 &&
              <TabFacebook
                handleGoBack={handleGoBack}
                handleUpdate={handleUpdate}
                companyData={companyData}
              />)
            || (page === 3 &&
              <TabSkute
                handleGoBack={handleGoBack}
                handleUpdate={handleUpdate}
                companyData={companyData}
              />)
            || (page === 4 &&
              <TabChat
                handleGoBack={handleGoBack}
                handleUpdate={handleUpdate}
                companyData={companyData}
              />)
            || (page === 5 &&
              <TabWhatsappQrCode
                companyData={companyData}
              />)
            || (page === 6 &&
              <TabInstagram
                handleGoBack={handleGoBack}
                handleUpdate={handleUpdate}
                companyData={companyData}
              />)
          }
        </>
      )}
    </div>
  );
}
